import React from 'react';
import { Icon } from 'js/components/common/Icon';
import buildClassName from 'js/utils/classNameBuilder.util';
import style from './index.scss';

export default ({
    classNames = {},
    className = '',
    disabled,
    separator,
    ...props // data attributes
}) => (
    <Icon
        type="bottomArrowForDropDowns"
        disabled={disabled}
        className={`${style.icon} ${style.dropDownIcon} ${className}`}
        {...props}
    >
        {separator && <span className={buildClassName(['separator'], style, classNames)} />}
    </Icon>
);
